import React, { useState, useRef, useEffect } from "react";

export default function AddOnTimer({ services, setAddOnSavings, currentTime }) {
  const [addOnTimer, setAddOnTimer] = useState();
  const startTimeRef = useRef(currentTime);
  const endTimeRef = useRef();

  useEffect(() => {
    if (!services?.length) return;

    endTimeRef.current = new Date(
      services.reduce(function (a, b) {
        return a.end_time < b.end_time ? a : b;
      }).end_time
    ).getTime();

    setAddOnSavings(
      services
        .filter(
          (item) => item?.service_info?.service_type !== "instant discount"
        )
        .reduce(
          (partialSum, el) =>
            partialSum +
            ((el?.service_info?.price_without_offer || 0) -
              (el?.service_info?.offer_price || 0)),
          0
        )
    );

    startTimer();
  }, [services]);

  const startTimer = () => {
    let timerRef = setInterval(() => {
      let distance = endTimeRef.current - startTimeRef.current;
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance < 0) {
        clearInterval(timerRef);
        setAddOnTimer(null);
      } else {
        setAddOnTimer({
          days,
          hours,
          minutes,
          seconds,
        });
        startTimeRef.current = startTimeRef.current + 1000;
      }
    }, 1000);
  };

  const convertToGrouping = (data) => {
    return String(data).padStart(2, "0");
  };

  return addOnTimer ? (
    <div className="addOnTimerCnt">
      <span className="font-weight-bold sofia-pro">Offer Ends in</span>

      <div className="addOnTimerContainer">
        {addOnTimer?.days > 0 && (
          <>
            <div className="timerSection">
              <p className="timerValue">{convertToGrouping(addOnTimer.days)}</p>
            </div>
            <div className="timerSeparator">:</div>
          </>
        )}
        <div className="timerSection">
          <p className="timerValue">{convertToGrouping(addOnTimer.hours)}</p>
        </div>
        <div className="timerSeparator">:</div>
        <div className="timerSection">
          <p className="timerValue">{convertToGrouping(addOnTimer.minutes)}</p>
        </div>
        <div className="timerSeparator">:</div>
        <div className="timerSection">
          <p className="timerValue">{convertToGrouping(addOnTimer.seconds)}</p>
        </div>
      </div>
    </div>
  ) : null;
}
